(function () {
    'use strict';

    var module = angular.module('imApp');

    module.component('developMenu', {
        templateUrl: 'views/components/views/developMenu/developMenu.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['stateService', function (stateService) {
            var vm = this;

            vm.model = {
                name: stateService.getCurrentName()
            };
        }]
    });
})();
